<template>
  <div class="xy-image">
    <img ref="imageRef" :src="mSrc" alt="" :style="{ objectFit: props.fit }" />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { info, defaultProps } from './config'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const imageRef = ref(null)
let hasRetried = false
const mSrc = ref(props.src)

watch(
  () => props.src,
  (newVal) => {
    mSrc.value = newVal
  }
)

onMounted(() => {
  if (imageRef.value) {
    imageRef.value.addEventListener('error', (event) => {
      if (!hasRetried) {
        hasRetried = true
        const failedImageUrl = event.target.src
        console.error('图片加载失败', failedImageUrl)
        mSrc.value = props.src + '?t=' + new Date().getTime()
      }
    })
  }
})
</script>

<style lang="scss" scoped>
.xy-image {
  width: 100%;
  height: 100%;
  position: relative;
}
img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
